import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/pages/ModalLoan.css';

function UpdateSliderForm({ data, closeModal, refreshGallery }) {
  // Initialize sliderItem with data or a default empty object structure
  const [sliderItem, setSliderItem] = useState(data || { sliderImgDescription: '', images: [] });

  // Handle deleting an image from the list
  const handleDeleteImage = async (index) => {
    try {
      const imageId = sliderItem._id; // The ID of the gallery item
      const imageIndex = index; // The index of the image to be deleted

      // Call the backend API to delete the image
      await axios.delete(`/api/gallery-items/img/${imageId}/${imageIndex}`);

      // Update the images in the state
      const updatedImages = [...sliderItem.images];
      updatedImages.splice(index, 1); // Remove the image at the specified index
      setSliderItem({ ...sliderItem, images: updatedImages });

      // Optionally, refresh the gallery data
      refreshGallery();
    } catch (err) {
      console.error('Error deleting image from gallery item:', err);
    }
  };

  const handleImageDescriptionChange = (e, index) => {
    const updatedImages = [...sliderItem.images];
    updatedImages[index].imgDescription = e.target.value;
    setSliderItem({ ...sliderItem, images: updatedImages });
  };

  const handleImageFileChange = (e, index) => {
  const file = e.target.files[0];
  const updatedImages = [...sliderItem.images];
  updatedImages[index].newImageFile = file;  // Store the new file separately
  console.log('Updated Image File: ', file);  // Log the file to see if it's being selected
  setSliderItem({ ...sliderItem, images: updatedImages });
};


  // Handle adding a new image field
  const handleAddImageField = () => {
    setSliderItem({
      ...sliderItem,
      images: [
        ...sliderItem.images,
        { imgDescription: '', newImageFile: null }, // New empty image field
      ],
    });
  };

const handleUpdate = async () => {
  try {
    const formData = new FormData();

    // Append non-image fields
    formData.append('section', sliderItem.sliderImgDescription);
    formData.append('isSlider', sliderItem.isSlider);
    formData.append('sliderImgDescription', sliderItem.sliderImgDescription);
    formData.append('_id', sliderItem._id);

    // Add images and descriptions to the form data
    sliderItem.images.forEach((image, index) => {
      if (image.newImageFile) {
        console.log('Appending new image to FormData:', image.newImageFile);
        // Append the image file under the 'images' field (without index)
        formData.append('images', image.newImageFile);  // 'images' field will contain multiple files
      }

      // Ensure imgDescription is a string and append it with its corresponding index
      const description = Array.isArray(image.imgDescription)
        ? image.imgDescription.join(', ') // Join if it's an array (optional, depending on your data structure)
        : image.imgDescription || ''; // Default to an empty string if no description

      // Append the description with a field name like 'images[0].imgDescription'
      formData.append(`images[${index}].imgDescription`, description);
    });

    // Log the formData entries for debugging
    for (let pair of formData.entries()) {
      console.log(pair[0] + ': ' + pair[1]);
    }

    // Send the form data to the backend
    const response = await axios.put(`/api/gallery-items/${sliderItem._id}`, formData);

    // Handle success (refresh gallery and close modal)
    refreshGallery();
    closeModal();
  } catch (err) {
    console.error('Error updating the gallery item:', err);
  }
};






  const handleDeleteGalleryItem = async () => {
    try {
      // Call the backend API to delete the entire gallery item
      await axios.delete(`/api/delete-gallery-item/${sliderItem._id}`);
      refreshGallery(); // Refresh the gallery data
      closeModal(); // Close the modal after successful deletion
    } catch (err) {
      console.error('Error deleting gallery item:', err);
    }
  };

  return (
    <div style={{ overflow: "scroll", height: "70vh" }}>
      <h3>Update Slider Form</h3>

      <input
        type="text"
        value={sliderItem.sliderImgDescription}
        onChange={(e) => setSliderItem({ ...sliderItem, sliderImgDescription: e.target.value })}
        placeholder="Slider Image Description"
      />

      <h4>Existing Images</h4>
      {sliderItem.images.map((img, index) => (
        <div key={index} style={{ marginBottom: "15px", paddingBottom: "10px", borderBottom: "1px solid #ddd" }}>
          <input
            type="text"
            value={img.imgDescription}
            onChange={(e) => handleImageDescriptionChange(e, index)}
            placeholder="Image Description"
          />
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleImageFileChange(e, index)}
            style={{ marginTop: "5px" }}
          />
          <button
            onClick={() => handleDeleteImage(index)}
            style={{
              marginLeft: "10px",
              background: "#dc3545",
              color: "#fff",
              border: "none",
              padding: "5px 10px",
              borderRadius: "4px",
              cursor: "pointer"
            }}
          >
            Delete
          </button>
        </div>
      ))}

      <button 
        onClick={handleAddImageField}
        style={{
          marginTop: "20px",
          background: "#28a745",
          color: "#fff",
          border: "none",
          padding: "5px 10px",
          borderRadius: "4px",
          cursor: "pointer"
        }}
      >
        Add New Image
      </button>

      <button onClick={handleUpdate} style={{ marginTop: "20px" }}>Update Gallery</button>
      
      <button 
        onClick={handleDeleteGalleryItem}
        style={{
          marginTop: "10px",
          background: "#dc3545",
          color: "#fff",
          border: "none",
          padding: "5px 10px",
          borderRadius: "4px",
          cursor: "pointer"
        }}
      >
        Delete Gallery Item
      </button>
    </div>
  );
}

export default UpdateSliderForm;
